import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=bd39d28a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd39d28a')) {
      api.createRecord('bd39d28a', component.options)
    } else {
      api.reload('bd39d28a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=bd39d28a&", function () {
      api.rerender('bd39d28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/pricehelp.vue"
export default component.exports